
import { EventBus, TypeEventBus } from '../../../features/core/utils/event-bus';
import { Vue, Component, Prop } from 'vue-property-decorator';
import LabelWithValue from '../../core/components/Indicators/LabelWithValue.vue'

@Component({
  components: {
    LabelWithValue
  }
})
export default class AreaIndicator extends Vue {
  @Prop({default: '-'}) polygonsArea: string;
  calculatingPolygonArea: boolean = false;

  mounted(){
    EventBus.$on(TypeEventBus.CALCULATING_POLYGON_AREA, (value) => {
        this.calculatingPolygonArea = value
      })
  }
}
